// INDEX.JS 
import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/barlow/400.css";
import "@fontsource/barlow/500.css";
import "@fontsource/barlow/600.css";
import "@fontsource/barlow-condensed/600.css";
import "@fontsource/barlow-condensed/700.css";
import "./index.css";
import "./styles/native-ui-v3.css";
import "./styles/native-auth-v3.css";
import "./styles/native-protocol-v3.css";
import App from "./App";
import queryClient from "@/lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { HapticsProvider } from "@/haptics/HapticsProvider";
import { isNativeApp } from "@/lib/runtime";

const root = ReactDOM.createRoot(document.getElementById("root"));

function renderApp() {
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <HapticsProvider defaultEnabled={true}>
          <App />
          <ReactQueryDevtools initialIsOpen={false} />
        </HapticsProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
}

async function preloadNativeFonts() {
  if (!isNativeApp() || !document.fonts?.load) return;

  const fontLoads = [
    '400 1em "Barlow"',
    '500 1em "Barlow"',
    '600 1em "Barlow"',
    '600 1em "Barlow Condensed"',
    '700 1em "Barlow Condensed"',
  ].map((font) => document.fonts.load(font));

  await Promise.race([
    Promise.allSettled(fontLoads),
    new Promise((resolve) => window.setTimeout(resolve, 1200)),
  ]);
}

preloadNativeFonts().finally(renderApp);

// >>> Registrera service worker här <<<
async function removeNativeWebWorkerState() {
  if (!("serviceWorker" in navigator)) return;

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));

    if ("caches" in window) {
      const cacheKeys = await window.caches.keys();
      await Promise.all(cacheKeys.map((cacheKey) => window.caches.delete(cacheKey)));
    }
  } catch (error) {
    console.warn("[Native] Failed to clear previous web worker state:", error);
  }
}

if (isNativeApp()) {
  void removeNativeWebWorkerState();
} else if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((reg) => {
        console.log("[SW] registered, scope:", reg.scope);
        return navigator.serviceWorker.ready.then((readyReg) => {
          console.log("[SW] ready, active:", readyReg.active?.scriptURL || "none");
          return reg;
        });
      })
      .catch((err) => console.error("[SW] register failed:", err));
  });
} else {
  console.warn("[SW] serviceWorker not supported in this browser");
}
